import { Injectable } from '@angular/core';
import { IResultFormattedItem } from './interfaces/result-formatted-item';

@Injectable({
  providedIn: 'root'
})
export class ExportService {
  public exportVantaShotJSON(fileName: string, shotData: IResultFormattedItem | Blob): void {
    const dataStr =
      'data:text/json;charset=utf-8,' +
      encodeURIComponent(JSON.stringify(shotData));
    const downloadAnchorNode = document.createElement('a');
    downloadAnchorNode.setAttribute('href', dataStr);
    downloadAnchorNode.setAttribute(
      'download',
      fileName
    );
    document.body.appendChild(downloadAnchorNode);
    downloadAnchorNode.click();
    downloadAnchorNode.remove();
    }

  public exportVantaShotsJSON(fileName: string, data: Blob): void {
    this.downloadFile(fileName, data);
  }

  public exportVantaShotCSV(fileName: string, data: Blob): void {
    this.downloadFile(fileName, data);
  }

  private downloadFile(fileName: string, data: Blob) {
    const a = document.createElement('a');
    a.setAttribute('style', 'display:none;');
    document.body.appendChild(a);
    a.download = `${fileName}`;
    a.href = URL.createObjectURL(data);
    a.target = '_blank';
    a.click();
    document.body.removeChild(a);
  }
}
